module.exports = __webpack_public_path__ + "static/media/cherry_pop.avatarux.a318ced4.jpeg";